/* global gaTrack */
/* eslint-env browser */
import { ready, find } from 'domassist';


ready(() => {
  if (window.pageName) {
    const category = `${window.pageName}--cards`;
    find('[data-track-card]').forEach((el) => {
      gaTrack.track(el, {
        category,
        label: el.getAttribute('data-track-card'),
        action: find('[data-track-title]', el)[0].innerHTML
      });
    });
    find('[data-track-card-partner]').forEach((el) => {
      const atags = find('a', el);
      const title = find('[data-track-title]', el)[0].innerHTML;
      const cat = el.getAttribute('data-track-card-partner');
      atags.forEach((aEl) => {
        gaTrack.track(aEl, {
          category,
          label: cat,
          action: title
        });
      });
    });
  }
});
